export class CommentLinks {
    constructor(imageViewer) {
        this._imageViewer = imageViewer;
    }

    get(comment) {
        const props = this._imageViewer.props;
        return `${window.location.origin}${props.location.pathname}?comment_id=${comment.id}`;
    }
}